import {
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { transporterJson } from "../../../DynamicFormsJson/MastersJSON/transporter";

class TransporterView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: transporterJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            this.setState({
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Transporter For",
                  value:
                    data.data !== null && data.data.transporterFor !== null
                      ? data.data.transporterFor == "0"
                        ? "Admin"
                        : "Distributor"
                      : "",
                },
                // {
                //   xs: 12,
                //   sm: 6,
                //   md: 6,
                //   lg: 6,
                //   label: "Transporter For",
                //   value: (
                //     <Grid item xs={12} sm={12} md={12} lg={12} container>
                //       <FormControl component="fieldset">
                //         <RadioGroup
                //           value={data.data.transporterFor}
                //           row
                //           name="transporterFor"
                //         >
                //           <FormControlLabel
                //             value="0"
                //             control={<Radio disabled />}
                //             label="Admin"
                //           />
                //           <FormControlLabel
                //             value="1"
                //             control={<Radio disabled />}
                //             label="Distributor"
                //           />
                //         </RadioGroup>
                //       </FormControl>
                //     </Grid>
                //   ),
                // },

                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Area",
                  value:
                    data.data.area !== null && data.data.area.name !== null
                      ? data.data.area.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Stock Holder Type",
                  value:
                    data.data.stockStakeHolderType !== null &&
                    data.data.stockStakeHolderType.name !== null
                      ? data.data.stockStakeHolderType.name
                      : "",
                },

                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Stock Holder Name",
                  value:
                    data.data.stockStakeHolder !== null &&
                    data.data.stockStakeHolder.firmName !== null
                      ? data.data.stockStakeHolder.firmName
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Transporter Name",
                  value:
                    data.data !== null && data.data.name !== null
                      ? data.data.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "SPOC",
                  value:
                    data.data !== null && data.data.spocName !== null
                      ? data.data.spocName
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Contact No.",
                  value:
                    data.data.stockStakeHolder !== null &&
                    data.data.stockStakeHolder.contactPersonNo !== null
                      ? data.data.stockStakeHolder.contactPersonNo
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Address",
                  value:
                    data.data !== null && data.data.address !== null
                      ? data.data.address
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Pincode",
                  value:
                    data.data !== null && data.data.pincode !== null
                      ? data.data.pincode
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "GST Number",
                  value:
                    data.data.stockStakeHolder !== null &&
                    data.data.stockStakeHolder.gstNo !== null
                      ? data.data.stockStakeHolder.gstNo
                      : "-",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Sort Order No",
                  value:
                    data.data !== null && data.data.sortOrder !== null
                      ? data.data.sortOrder
                      : "",
                },
              ],
            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Transporter View"}
            fieldMeta={[]}
            apiBaseURL={transporterJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(TransporterView);
